export default __webpack_public_path__ + "static/media/Create_Custom_Role.f5c1f6ca.png";